module.exports = __webpack_public_path__ + "static/media/shuffleboard.335a9178.svg";